export default __webpack_public_path__ + "static/media/Swiss-Fresh-Air.a8e4ce01.jpg";